const s = {
  name: "Store2",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,10h9v12H4V10z M6,12v8h5v-8H6z"/>
		<path class="st0" d="M28,0H0v30h28V8h2v7c0,2.2,1.8,4,4,4s4-1.8,4-4V8h2V6H28V0z M36,8v3.5c-0.6-0.3-1.3-0.5-2-0.5s-1.4,0.2-2,0.5
			V8H36z M36,15c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S36,13.9,36,15z M24,28V10h-9v18H2V8h24v20H24z M17,28V12h5v16H17z M26,6H2V2
			h24V6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Store2
};
